import PropTypes from 'prop-types'
import endOfDay from 'date-fns/endOfDay'
import startOfDay from 'date-fns/startOfDay'

import {ErrorsShape} from '../../../common/PropTypes.js'
import {
  isNonZeroPositiveInteger,
  isNonZeroPositiveNumeric,
} from '../../../common/utils.js'
import {formSelector} from '../../../store.js'
import ReportInterval from './ReportInterval.js'
import DateRange from './DateRange.js'
import IntervalSummary from './IntervalSummary.js'
import {getTimeZonedDate} from '../../../common/date.js'
import {REPORT_INTERVAL_MONTH} from '../../../common/constants/Reports.js'
import TimeZone from './TimeZone.js'

export function dateFilterErrorsSelector(state, {formName}) {
  const {interval_type, interval_amount, start_date, end_date} = formSelector(
    state,
    {
      formName,
    },
  )
  const errors = {}

  if (interval_type) {
    if (
      interval_type === REPORT_INTERVAL_MONTH &&
      !isNonZeroPositiveInteger(interval_amount)
    ) {
      errors.interval_amount = 'Amount must be a positive whole number'
      errors.preventSave = true
    } else if (
      interval_type !== REPORT_INTERVAL_MONTH &&
      !isNonZeroPositiveNumeric(interval_amount)
    ) {
      errors.interval_amount = 'Amount must be a positive number'
      errors.preventSave = true
    }
  } else {
    if (!start_date) {
      errors.start_date = 'Date is required'
      errors.preventSave = true
    }

    if (!end_date) {
      errors.end_date = 'Date is required'
      errors.preventSave = true
    }

    if (start_date > end_date) {
      errors.end_date = 'End date must be after start date'
      errors.preventSave = true
    }
  }

  return errors
}

export function dateFilterPayloadParamsSelector(state, {formName}) {
  const {
    interval_type,
    interval_amount,
    interval_trunc,
    start_date,
    end_date,
    timezone,
  } = formSelector(state, {formName})

  const params = {timezone}

  if (interval_type) {
    params.interval_type = interval_type
    params.interval_amount = Number(interval_amount)
    params.interval_trunc = interval_trunc
  } else {
    params.start_date = startOfDay(
      getTimeZonedDate(start_date, timezone),
    ).toISOString()
    params.end_date = endOfDay(
      getTimeZonedDate(end_date, timezone),
    ).toISOString()
  }

  return params
}

export function dateFilterPayloadV2ParamsSelector(
  state,
  {formName, prepend = ''},
) {
  const {
    interval_type,
    interval_amount,
    interval_trunc,
    start_date,
    end_date,
    timezone,
  } = formSelector(state, {formName})

  const params = {timezone}

  if (interval_type) {
    params[`${prepend}interval_type`] = interval_type
    params[`${prepend}interval_amount`] = Number(interval_amount)
    params[`${prepend}interval_trunc`] = interval_trunc
  } else {
    params[`${prepend}after`] = startOfDay(
      getTimeZonedDate(start_date, timezone),
    ).toISOString()
    params[`${prepend}before`] = endOfDay(
      getTimeZonedDate(end_date, timezone),
    ).toISOString()
  }

  return params
}

export default function DateFilters({formName, errors, dividerButton}) {
  return (
    <>
      <ReportInterval formName={formName} errors={errors} />
      <DateRange formName={formName} errors={errors} />
      <IntervalSummary formName={formName} errors={errors} />
      <TimeZone
        formName={formName}
        errors={errors}
        dividerButton={dividerButton}
      />
    </>
  )
}

DateFilters.propTypes = {
  formName: PropTypes.string.isRequired,
  errors: ErrorsShape.isRequired,
  dividerButton: PropTypes.bool,
}
